export default __webpack_public_path__ + "media/easy-breezy2x.4b74b555.png";